import React from "react";
import classnames from "classnames";

const LazyByScrollComponentWrapper = ({
    pivotRef,
    showLazyCmp,
    LazyCmp,
    lazyComponentLoaded,
    offset,
}) => {
    return (
        <div
            className={classnames("lazy-by-scroll__component-wrapper", {
                "lazy-by-scroll__component-wrapper--skeleton": !lazyComponentLoaded,
            })}
        >
            <div
                className="lazy-by-scroll__pivot"
                ref={pivotRef}
                style={{ top: `${offset}px` }}
            ></div>
            {showLazyCmp && (
                <React.Suspense fallback={null}>
                    <LazyCmp></LazyCmp>
                </React.Suspense>
            )}
        </div>
    );
};

export default React.memo(LazyByScrollComponentWrapper);
